import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../views/Login.vue';
import Dashboard from '../views/Dashboard.vue'
import History from '../views/History.vue'
import AccessDenied from '../views/AccessDenied.vue'
import UploadFiles from '../views/UploadFiles.vue'
import Layout from '../components/Layout'
import store from '../store'
import { verifyToken } from '../utils/serverRequests'
import { configEnv } from '../config/config'

Vue.use(VueRouter);

const routes = [
  { 
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      name: 'Inicio de sesión'
    }
  },  
  {
    path: '/manager-layout',
    name: 'Layout',
    component: Layout,
    children: [
      {
        path: '/history',
        name: 'history',
        component: History,
        meta: {
          requiresAuth: true,
          name: 'Historial'
        }
      },
      {
        path: '/upload-files',
        name: 'upload-files',
        component: UploadFiles,
        meta: {
          requiresAuth: true,
          name: 'Gestión de archivos'
        }
      },
      {
        path: '/dashboard/:dashboard?',
        name: 'dashboard',
        component: Dashboard,
        meta: {
          requiresAuth: true
        }
      },
    ]
  },
  {
    path: '/access-denied',
    name: 'AccessDenied',
    component: AccessDenied,
  },
];

const router = new VueRouter({
  routes,
});
router.afterEach((to, from) => {
  Vue.nextTick(() => {
      document.title = to.meta.name || 'Teca';
  });
});
router.beforeResolve((to, from, next) => {
  const token = localStorage.getItem(configEnv.tokenKey)
  const user = JSON.parse(localStorage.getItem(configEnv.userDataKey))
  if(token && user  && !store.state.jwt ) {
    verifyToken({ token })
      .then(response => {
        let data = response.data
        if(data.isVerified) {
          store.commit('definedUserData', user)
          store.commit('definedJwt', token)
          if(store.getters.hasPermissions(to.name)) {
            next()
          } else {
            next({ name: user.permissions[0] })
          }
          return
        }
      })
      .catch(error => {
        if(error.response.status === 401) {
          localStorage.removeItem(configEnv.tokenKey)
          localStorage.removeItem(configEnv.userDataKey)
          if(to.name != 'login') {
            next({ name: 'login' })
          } else {
            next()
          }
          return
        }
        next()
      })
  } 
  else {
    if(!to.meta.requiresAuth) {
      if(store.state.jwt && to.name === 'login') {
        return;
      }
      next()
      return;
    }
    if(store.state.jwt) {
      if(store.getters.hasPermissions(to.name)) {
        next()
      } else {
        next('/access-denied')
      }
      return
    }
    next({ name: 'login' })
  }
})
export default router;
